export enum EGender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  UNKNOWN = 'UNKNOWN',
}

export enum EPartsUpper {
  PATRONYMIC = 'PATRONYMIC',
  NAME = 'NAME',
  SURNAME = 'SURNAME',
}

export enum EPartsLower {
  patronymic = 'patronymic',
  name = 'name',
  surname = 'surname',
}

export interface IData {
  surname: string | null;
  name: string | null;
  patronymic: string | null;
  gender: EGender;
}

export interface ISuggestion {
  value: string;
  unrestricted_value: string;
  data: IData;
}

export interface ISuggestions {
  suggestions: ISuggestion[];
}
